import createAxios from "./axiosHttp";

function getVehicles(pagination, query, sort) {
  const axios = createAxios();
  const urlPath = "ttmm/vehicle/ql";
  return axios.post(urlPath, { pagination, query, sort });
}

function exportar(pagination, query, sort) {
  const axios = createAxios();
  const urlPath = "ttmm/vehicle/ql/export";
  return axios.post(
    urlPath,
    { pagination, query, sort },
    { responseType: "arraybuffer" }
  );
}

function getActiveVehicles(date) {
  const axios = createAxios();
  const urlPath = "ttmm/vehicle";
  return axios.get(urlPath, { params: { date } });
}

function getVehicleById(vehicle_id) {
  const axios = createAxios();
  const urlPath = `ttmm/vehicle/${vehicle_id}`;
  return axios.get(urlPath);
}

function createVehicle(body) {
  const axios = createAxios();
  const urlPath = "ttmm/vehicle";
  return axios.post(urlPath, body);
}

function updateVehicle(body, vehicle_id) {
  const axios = createAxios();
  const urlPath = `ttmm/vehicle/${vehicle_id}`;
  return axios.put(urlPath, body);
}

function deleteVehicle(vehicle_ids) {
  const axios = createAxios();
  const urlPath = `ttmm/vehicle/${vehicle_ids}`;
  return axios.delete(urlPath);
}

export const vehicleService = {
  getVehicles,
  exportar,
  getActiveVehicles,
  getVehicleById,
  createVehicle,
  updateVehicle,
  deleteVehicle,
};
